function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function OnlineAuctionIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2996 18.9436L5 13.6449L13.6463 5L18.9459 10.2988L16.6638 12.5806L21.9943 16.9402L22.0057 16.9497C22.6101 17.4599 22.9646 18.1905 22.9977 18.9736C23.0311 19.7657 22.7322 20.5186 22.1822 21.0716L22.1786 21.0752L21.0774 22.1762C20.5915 22.6621 19.8634 23.0566 18.9384 22.9933C18.1696 22.9506 17.4542 22.598 16.9521 22.0034L16.9426 21.9921L12.5818 16.6618L10.2996 18.9436ZM19.0567 21.0848C19.3329 21.1071 19.5472 21.0025 19.7255 20.8241L20.8267 19.7231C21.0051 19.5438 21.0981 19.3074 21.0874 19.0544C21.0768 18.8024 20.9653 18.5737 20.7724 18.4109L15.3615 13.9856L13.987 15.3599L18.413 20.7699C18.5759 20.9627 18.8046 21.0742 19.0567 21.0848ZM10.2996 16.2399L7.70421 13.6449L13.6463 7.70377L16.2417 10.2988L10.2996 16.2399Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C4.58172 1 1 4.58172 1 9H3C3 5.68629 5.68629 3 9 3L9 1ZM5 9C5 6.79086 6.79086 5 9 5V6.99476L8.99463 6.99475C7.89006 6.99475 6.99463 7.89018 6.99463 8.99475L6.99464 9H5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 23L10 21H2L1 23H11Z",
    fill: "currentColor"
  }));
}
export function OnlineAuctionIconSmall(props) {
  return ___EmotionJSX(OnlineAuctionIcon, _extends({
    size: "small"
  }, props));
}